import { MouseEventHandler, ReactNode } from 'react';
import { classNames } from '../../../../shared/types/className';

interface ChipProps {
    children?: ReactNode;
    onClick?: MouseEventHandler;
    active?: boolean;
}

export const Chip = ({ children, onClick, active }: ChipProps) => {
    return (
        <button
            onClick={onClick}
            className={classNames(
                'chip',
                active ? 'chip--active' : 'chip--inactive'
            )}
        >
            {children}
        </button>
    );
};
